// Bireysel Kişiler Mock Verileri
// Müşteriler, arsa sahipleri ve diğer bireysel kişiler

export const mockIndividuals = [
    {
        id: 'ind-1',
        name: 'Emre Karaca',
        phone: '0555 111 11 11',
        email: 'emre.karaca@email.com',
        tcNo: '12345678901',
        address: 'Atatürk Cad. No:45, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1985-03-15',
        occupation: 'Mühendis',
        workplace: 'ABC Teknoloji A.Ş.',
        notes: 'A-3 dairesi için kapora ödedi. Taksitli ödeme planı tercih ediyor.',
        apartments: [
            { id: 'apt-3', number: 'A-3', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2800000 }
        ],
        payments: [
            { id: 'pay-1', date: '2025-06-15', amount: 500000, type: 'kapora', description: 'A-3 dairesi kapora' },
            { id: 'pay-2', date: '2025-07-15', amount: 200000, type: 'taksit', description: '1. taksit ödemesi' },
            { id: 'pay-3', date: '2025-08-15', amount: 200000, type: 'taksit', description: '2. taksit ödemesi' },
        ],
        totalPaid: 900000,
        totalRemaining: 1900000,
        createdAt: '2025-06-10',
    },
    {
        id: 'cust-004',
        name: 'Veli Arslan',
        phone: '0555 999 88 77',
        email: 'veli.arslan@email.com',
        tcNo: '10293847566',
        address: 'Bostancı Cad. No:12, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1980-05-15',
        occupation: 'Esnaf',
        workplace: 'Arslan Ticaret',
        notes: 'C Blok Daire 4 için ödemelerini vadeli çeklerle yapıyor.',
        apartments: [
            { id: 'apt-c4', number: 'C Blok - Daire 4', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 3000000 }
        ],
        payments: [
            { id: 'pay-v1', date: '2025-01-15', amount: 500000, type: 'kapora', description: 'Peşinat' }
        ],
        totalPaid: 500000,
        totalRemaining: 2500000,
        createdAt: '2025-01-10',
    },
    {
        id: 'ind-2',
        name: 'Sevgi Korkmaz',
        phone: '0555 111 11 12',
        email: 'sevgi.korkmaz@email.com',
        tcNo: '23456789012',
        address: 'Cumhuriyet Mah. Lale Sok. No:12, Beşiktaş/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1978-08-22',
        occupation: 'Doktor',
        workplace: 'Özel Hayat Hastanesi',
        notes: 'Peşin ödeme yaptı. Tapu devri bekliyor.',
        apartments: [
            { id: 'apt-5', number: 'A-5', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 3200000 }
        ],
        payments: [
            { id: 'pay-4', date: '2025-05-20', amount: 3200000, type: 'pesin', description: 'Peşin ödeme' },
        ],
        totalPaid: 3200000,
        totalRemaining: 0,
        createdAt: '2025-05-18',
    },
    {
        id: 'cust-005',
        name: 'Hasan Yıldırım',
        phone: '0555 888 77 66',
        email: 'hasan.yildirim@email.com',
        tcNo: '29384756102',
        address: 'Göztepe Mah. No:34, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-2',
        birthDate: '1975-11-20',
        occupation: 'Müteahhit',
        workplace: 'Yıldırım İnşaat',
        notes: 'Global projesinden daire aldı.',
        apartments: [
            { id: 'apt-g5', number: 'B Blok - Daire 5', constructionName: 'Global Rezidans', status: 'sold', price: 4200000 }
        ],
        payments: [
            { id: 'pay-h1', date: '2025-02-20', amount: 1200000, type: 'kapora', description: 'Peşinat' }
        ],
        totalPaid: 1200000,
        totalRemaining: 3000000,
        createdAt: '2025-02-15',
    },
    {
        id: 'ind-3',
        name: 'Hüseyin Aktaş',
        phone: '0555 111 11 13',
        email: 'huseyin.aktas@email.com',
        tcNo: '34567890123',
        address: 'İstiklal Cad. No:78, Beyoğlu/İstanbul',
        role: 'landowner',
        roleLabel: 'Arsa Sahibi',
        constructionId: 'const-1',
        birthDate: '1965-12-03',
        occupation: 'Emekli',
        workplace: '-',
        notes: 'Yeşil Park projesi arsa sahibi. %30 hisse karşılığı 5 daire alacak.',
        apartments: [
            { id: 'apt-1', number: 'A-1', constructionName: 'Yeşil Park Konutları', status: 'reserved', price: 0 },
            { id: 'apt-2', number: 'A-2', constructionName: 'Yeşil Park Konutları', status: 'reserved', price: 0 },
        ],
        payments: [],
        landSharePercentage: 30,
        landShareUnits: 5,
        createdAt: '2025-01-15',
    },
    {
        id: 'ind-4',
        name: 'Derya Güneş',
        phone: '0555 111 11 14',
        email: 'derya.gunes@email.com',
        tcNo: '45678901234',
        address: 'Bağdat Cad. No:156, Maltepe/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-2',
        birthDate: '1990-05-28',
        occupation: 'Avukat',
        workplace: 'Güneş Hukuk Bürosu',
        notes: 'Global projesinden daire aldı. Aylık taksit ödüyor.',
        apartments: [
            { id: 'apt-20', number: 'B-4', constructionName: 'Global Rezidans', status: 'sold', price: 4500000 }
        ],
        payments: [
            { id: 'pay-5', date: '2025-07-01', amount: 1000000, type: 'kapora', description: 'Kapora' },
            { id: 'pay-6', date: '2025-08-01', amount: 250000, type: 'taksit', description: '1. taksit' },
        ],
        totalPaid: 1250000,
        totalRemaining: 3250000,
        createdAt: '2025-06-28',
    },
    {
        id: 'ind-5',
        name: 'Burak Özdemir',
        phone: '0555 111 11 15',
        email: 'burak.ozdemir@email.com',
        tcNo: '56789012345',
        address: 'Eski Bağdat Cad. No:89, Kartal/İstanbul',
        role: 'investor',
        roleLabel: 'Yatırımcı',
        constructionId: 'const-2',
        birthDate: '1970-11-15',
        occupation: 'İş İnsanı',
        workplace: 'Özdemir Holding',
        notes: '3 daire satın aldı. Yatırım amaçlı.',
        apartments: [
            { id: 'apt-21', number: 'C-1', constructionName: 'Global Rezidans', status: 'sold', price: 5200000 },
            { id: 'apt-22', number: 'C-2', constructionName: 'Global Rezidans', status: 'sold', price: 5200000 },
            { id: 'apt-23', number: 'C-3', constructionName: 'Global Rezidans', status: 'reserved', price: 5200000 },
        ],
        payments: [
            { id: 'pay-7', date: '2025-04-10', amount: 10000000, type: 'pesin', description: '2 daire peşin' },
            { id: 'pay-8', date: '2025-05-10', amount: 2000000, type: 'kapora', description: '3. daire kapora' },
        ],
        totalPaid: 12000000,
        totalRemaining: 3600000,
        createdAt: '2025-04-05',
    },
    {
        id: 'ind-6',
        name: 'Elif Tuncer',
        phone: '0555 111 11 16',
        email: 'elif.tuncer@email.com',
        tcNo: '67890123456',
        address: 'Moda Cad. No:34, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1988-02-14',
        occupation: 'Öğretmen',
        workplace: 'Kadıköy Anadolu Lisesi',
        notes: 'B bloktan daire aldı. Düzenli taksit ödemesi yapıyor.',
        apartments: [
            { id: 'apt-10', number: 'B-2', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2600000 }
        ],
        payments: [
            { id: 'pay-9', date: '2025-06-01', amount: 400000, type: 'kapora', description: 'Kapora' },
            { id: 'pay-10', date: '2025-07-01', amount: 150000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-11', date: '2025-08-01', amount: 150000, type: 'taksit', description: '2. taksit' },
        ],
        totalPaid: 700000,
        totalRemaining: 1900000,
        createdAt: '2025-05-28',
    },
    {
        id: 'ind-7',
        name: 'Kemal Ermiş',
        phone: '0555 111 11 17',
        email: 'kemal.ermiş@email.com',
        tcNo: '78901234567',
        address: 'Fenerbahçe Mah. Deniz Sok. No:5, Kadıköy/İstanbul',
        role: 'landowner',
        roleLabel: 'Arsa Sahibi',
        constructionId: 'const-2',
        birthDate: '1955-09-20',
        occupation: 'Emekli Bankacı',
        workplace: '-',
        notes: 'Global projesi arsa sahibi. %40 hisse, 8 daire alacak.',
        apartments: [],
        payments: [],
        landSharePercentage: 40,
        landShareUnits: 8,
        createdAt: '2025-06-01',
    },
    {
        id: 'ind-8',
        name: 'Melis Aydoğan',
        phone: '0555 111 11 18',
        email: 'melis.aydogan@email.com',
        tcNo: '89012345678',
        address: 'Acıbadem Cad. No:67, Üsküdar/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-2',
        birthDate: '1992-07-08',
        occupation: 'Yazılımcı',
        workplace: 'XYZ Teknoloji',
        notes: 'Deniz manzaralı daire tercih etti.',
        apartments: [
            { id: 'apt-25', number: 'A-5', constructionName: 'Global Rezidans', status: 'sold', price: 4800000 }
        ],
        payments: [
            { id: 'pay-12', date: '2025-08-01', amount: 1500000, type: 'kapora', description: 'Kapora' },
        ],
        totalPaid: 1500000,
        totalRemaining: 3300000,
        createdAt: '2025-07-25',
    },
    {
        id: 'ind-9',
        name: 'Oğuz Yalçın',
        phone: '0555 111 11 19',
        email: 'oguz.yalcin@email.com',
        tcNo: '90123456789',
        address: 'Kozyatağı Mah. İş Sok. No:23, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1975-04-12',
        occupation: 'Müteşebbis',
        workplace: 'Yalçın Ticaret',
        notes: '2 daire aldı, birini oğluna verecek.',
        apartments: [
            { id: 'apt-7', number: 'B-1', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2500000 },
            { id: 'apt-8', number: 'A-8', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2700000 },
        ],
        payments: [
            { id: 'pay-13', date: '2025-03-15', amount: 5200000, type: 'pesin', description: 'Peşin ödeme' },
        ],
        totalPaid: 5200000,
        totalRemaining: 0,
        createdAt: '2025-03-10',
    },
    {
        id: 'ind-10',
        name: 'Ceren Aksoy',
        phone: '0555 111 11 20',
        email: 'ceren.aksoy@email.com',
        tcNo: '01234567890',
        address: 'Suadiye Mah. Çınar Sok. No:11, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-2',
        birthDate: '1995-01-25',
        occupation: 'Grafik Tasarımcı',
        workplace: 'Freelance',
        notes: 'Küçük daire tercih etti, ödeme planı devam ediyor.',
        apartments: [
            { id: 'apt-30', number: 'B-8', constructionName: 'Global Rezidans', status: 'sold', price: 3800000 }
        ],
        payments: [
            { id: 'pay-14', date: '2025-07-20', amount: 800000, type: 'kapora', description: 'Kapora' },
            { id: 'pay-15', date: '2025-08-20', amount: 200000, type: 'taksit', description: '1. taksit' },
        ],
        totalPaid: 1000000,
        totalRemaining: 2800000,
        createdAt: '2025-07-18',
    },
    {
        id: 'ind-11',
        name: 'Tolga Başaran',
        phone: '0555 111 11 21',
        email: 'tolga.basaran@email.com',
        tcNo: '11223344556',
        address: 'Cumhuriyet Cad. No:45, Üsküdar/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'const-1',
        birthDate: '1980-05-12',
        occupation: 'Mühendis',
        workplace: 'Başaran Mühendislik',
        notes: 'B bloktan daire aldı. Düzenli taksit ödemesi yapıyor.',
        apartments: [
            { id: 'apt-11', number: 'B-3', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2600000 }
        ],
        payments: [
            { id: 'pay-16', date: '2025-06-01', amount: 400000, type: 'kapora', description: 'Kapora' },
            { id: 'pay-17', date: '2025-07-01', amount: 150000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-18', date: '2025-08-01', amount: 150000, type: 'taksit', description: '2. taksit' },
        ],
        totalPaid: 700000,
        totalRemaining: 1900000,
        createdAt: '2025-05-28',
    },
    // --- Yeni Satışlardan Gelen Müşteriler ---
    {
        id: 'ind-12',
        name: 'Burcu Deniz',
        phone: '0555 222 33 44',
        email: 'burcudeniz@email.com',
        tcNo: '10293847561',
        address: 'Nispetiye Cad. No:1, Beşiktaş/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'c2',
        birthDate: '1989-03-30',
        occupation: 'Mimar',
        workplace: 'Deniz Mimarlık',
        notes: 'B-12 Dairesi için yüksek peşinat ödedi.',
        apartments: [
            { id: 'apt-b12', number: 'B-12', constructionName: 'Global Rezidans', status: 'sold', price: 3100000 }
        ],
        payments: [
            { id: 'pay-20', date: '2025-10-01', amount: 1000000, type: 'kapora', description: 'Peşinat' },
            { id: 'pay-21', date: '2025-11-01', amount: 70000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-22', date: '2025-12-01', amount: 70000, type: 'taksit', description: '2. taksit' },
            { id: 'pay-23', date: '2026-01-01', amount: 70000, type: 'taksit', description: '3. taksit' }
        ],
        totalPaid: 1210000,
        totalRemaining: 1890000,
        createdAt: '2025-09-15',
    },
    {
        id: 'ind-13',
        name: 'Okan Kılıç',
        phone: '0555 333 44 55',
        email: 'okan.kilic@email.com',
        tcNo: '19283746501',
        address: 'Atatürk Orman Çiftliği Yolu No:4, Ankara',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'c1',
        birthDate: '1982-11-12',
        occupation: 'Doktor',
        workplace: 'Şehir Hastanesi',
        notes: 'C-5 Dairesi satışında son 3 taksiti gecikmeli.',
        apartments: [
            { id: 'apt-c5', number: 'C-5', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2150000 }
        ],
        payments: [
            { id: 'pay-24', date: '2025-10-10', amount: 350000, type: 'kapora', description: 'Peşinat' },
            { id: 'pay-25', date: '2025-11-10', amount: 50000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-26', date: '2025-12-10', amount: 50000, type: 'taksit', description: '2. taksit' },
            { id: 'pay-27', date: '2026-01-10', amount: 50000, type: 'taksit', description: '3. taksit' }
        ],
        totalPaid: 500000,
        totalRemaining: 1650000,
        createdAt: '2025-09-20',
    },
    {
        id: 'ind-14',
        name: 'Merve Korkmaz',
        phone: '0555 444 55 66',
        email: 'merve.korkmaz@email.com',
        tcNo: '98765432101',
        address: 'Bebek Sahil Yolu No:20, Beşiktaş/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'c2',
        birthDate: '1995-07-22',
        occupation: 'İşletmeci',
        workplace: 'Korkmaz Cafe',
        notes: 'A-15 Dairesi A Blok. 50 ay vade.',
        apartments: [
            { id: 'apt-a15', number: 'A-15', constructionName: 'Global Rezidans', status: 'sold', price: 3700000 }
        ],
        payments: [
            { id: 'pay-28', date: '2025-11-05', amount: 1200000, type: 'kapora', description: 'Peşinat' },
            { id: 'pay-29', date: '2025-12-05', amount: 50000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-30', date: '2026-01-05', amount: 50000, type: 'taksit', description: '2. taksit' },
            { id: 'pay-31', date: '2026-02-05', amount: 50000, type: 'taksit', description: '3. taksit' }
        ],
        totalPaid: 1350000,
        totalRemaining: 2350000,
        createdAt: '2025-10-25',
    },
    {
        id: 'ind-15',
        name: 'Cem Altun',
        phone: '0555 555 66 77',
        email: 'cemaltun@email.com',
        tcNo: '45612378901',
        address: 'Cihangir Mah. Sıraselviler Cad. No:9, Beyoğlu/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'c2',
        birthDate: '1979-05-18',
        occupation: 'Yatırımcı',
        workplace: 'Kendi İşi',
        notes: 'B-18 dairesi. Nakit akışı güçlü.',
        apartments: [
            { id: 'apt-b18', number: 'B-18', constructionName: 'Global Rezidans', status: 'sold', price: 4000000 }
        ],
        payments: [
            { id: 'pay-32', date: '2025-12-01', amount: 1500000, type: 'kapora', description: 'Peşinat' },
            { id: 'pay-33', date: '2026-01-01', amount: 50000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-34', date: '2026-02-01', amount: 50000, type: 'taksit', description: '2. taksit' }
        ],
        totalPaid: 1600000,
        totalRemaining: 2400000,
        createdAt: '2025-11-15',
    },
    {
        id: 'ind-16',
        name: 'Derya Şen',
        phone: '0555 666 77 88',
        email: 'derya.sen@email.com',
        tcNo: '56781234901',
        address: 'Caddebostan Mah. İskele Sok No:12, Kadıköy/İstanbul',
        role: 'customer',
        roleLabel: 'Müşteri',
        constructionId: 'c1',
        birthDate: '1985-09-10',
        occupation: 'Eczacı',
        workplace: 'Şifa Eczanesi',
        notes: 'C-8 dairesi için ödemelerini düzenli yapıyor.',
        apartments: [
            { id: 'apt-c8', number: 'C-8', constructionName: 'Yeşil Park Konutları', status: 'sold', price: 2400000 }
        ],
        payments: [
            { id: 'pay-35', date: '2025-12-15', amount: 400000, type: 'kapora', description: 'Peşinat' },
            { id: 'pay-36', date: '2026-01-15', amount: 50000, type: 'taksit', description: '1. taksit' },
            { id: 'pay-37', date: '2026-02-15', amount: 50000, type: 'taksit', description: '2. taksit' },
            { id: 'pay-38', date: '2026-03-15', amount: 50000, type: 'taksit', description: '3. taksit' }
        ],
        totalPaid: 550000,
        totalRemaining: 1850000,
        createdAt: '2025-12-10',
    },
];

// Helper functions
export const getIndividualById = (id) => mockIndividuals.find(p => p.id === id);
export const getCustomerById = getIndividualById; // Alias

export const getIndividualsByConstructionId = (constructionId) => {
    if (!constructionId) return mockIndividuals;
    return mockIndividuals.filter(p => p.constructionId === constructionId);
};
export const getCustomersByConstructionId = getIndividualsByConstructionId; // Alias

export const getCustomers = () => mockIndividuals.filter(p => p.role === 'customer');
export const getLandowners = () => mockIndividuals.filter(p => p.role === 'landowner');
export const getInvestors = () => mockIndividuals.filter(p => p.role === 'investor');

export const getIndividualStats = (constructionId) => {
    const individuals = getIndividualsByConstructionId(constructionId);
    return {
        total: individuals.length,
        customers: individuals.filter(p => p.role === 'customer').length,
        landowners: individuals.filter(p => p.role === 'landowner').length,
        investors: individuals.filter(p => p.role === 'investor').length,
        totalReceived: individuals.reduce((sum, p) => sum + (p.totalPaid || 0), 0),
        totalRemaining: individuals.reduce((sum, p) => sum + (p.totalRemaining || 0), 0),
    };
};
export const getCustomerStats = getIndividualStats; // Alias

export default mockIndividuals;
